export default __webpack_public_path__ + "static/media/booking.4317957c.png";